module.exports = __webpack_public_path__ + "img/book-fair.21caebca.svg";